import { Container, Grid } from "@mui/material";
import React, { useContext, ReactElement } from "react";
import { AuthPageLayout } from "@/pages/auth/components";
import { LoginForm, LoginLinkSection } from "./";
import { usePageTitle } from "@/hooks";
import { useTextDomainContext } from "@/app/providers";

/**
 * Login component for user authentication
 * Displays login form and related links for password recovery and registration
 * @returns The login page component
 */
export function Login(): ReactElement {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  // Set page title
  usePageTitle(gettext("Login"));

  return (
    <AuthPageLayout>
      <Container sx={{ width: "100%" }}>
        <Grid container spacing={1} sx={{ width: "100%" }}>
          <Grid size={{ xs: 12 }}>
            <LoginForm />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <LoginLinkSection />
          </Grid>
        </Grid>
      </Container>
    </AuthPageLayout>
  );
}
